export default __webpack_public_path__ + "static/media/image3pro2.4854c8b5.jpeg";